import { Card, DatePicker, message, Space, Switch, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [ativeKey, setActiveKey] = useState("cost");
  const [stations, setStations] = useState(null);
  const [selectedRange, setSelectedRange] = useState([
    moment().startOf("days"),
    moment().endOf("days"),
  ]);

  const getStats = async (dates) => {
    const res = await apiRequest({
      path: apiPaths.stats + `?start_date=${dates[0]}&end_date=${dates[1]}`,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setStats(res);
  };
  const getStations = async () => {
    const res = await apiRequest({
      path: apiPaths.stations,
    });
    if (res.error) {
      return;
    }
    setStations(res.results);
  };

  useEffect(() => {
    getStations();
    getStats(selectedRange);
  }, [selectedRange]);

  const COLORS = ["#FFBB28", "#FF8042"];

  const RADIAN = Math.PI / 180;

  const handleRangeChange = async (dates) => {
    let dateFrom = dates[0].split(" ");
    dateFrom = dateFrom[0] + " 00:00:00";
    let dateTo = dates[1].split(" ");
    dateTo = dateTo[0] + " 23:59:59";
    setSelectedRange([dateFrom, dateTo]);
  };

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
    value,
    ...props
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <>
        <text {...props}>
          {ativeKey == "cost" ? "₹" + value : value + " rides"}
        </text>
        ;
        <text
          x={x}
          y={y}
          fill="white"
          textAnchor={x > cx ? "start" : "end"}
          dominantBaseline="central"
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      </>
    );
  };
  let data = stats
    ? [
        {
          name: "Supervisor Rides",
          count: stats.supervisor_rides?.count,
          cost: stats.supervisor_rides?.total_cost,
        },
        {
          name: "User Rides",
          count: stats.customer_rides?.count,
          cost: stats.customer_rides?.total_cost,
        },
      ]
    : [];

  return (
    <div>
      {stations ? (
        <>
          <div style={{ fontSize: 20 }}>Vehicle Availability</div>
          <div style={{ padding: 20, display: "flex", flexWrap: "wrap" }}>
            {stations.map((station, idx) => (
              <Card
                size="small"
                style={{ borderRadius: 10, marginRight: 20 }}
                key={idx}
              >
                <div>{station.name}</div>
                <div style={{ fontSize: 20 }}>
                  <span style={{ fontSize: 15, color: "#b7b7b7" }}>
                    {"Available: "}
                  </span>
                  {station.available_vehicles?.filter(
                    (vehicle) => !vehicle.current_ride
                  ).length || 0}
                </div>
              </Card>
            ))}
          </div>
        </>
      ) : null}
      {stats ? (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              // justifyContent: "flex-end",
              marginBottom: 15,
            }}
          >
            <div>
              <div style={{ fontSize: 20 }}>Dashboard</div>
              <div style={{ color: "#b7b7b7" }}>
                Note: Below stats is for the selected date range
              </div>
            </div>
            <div>
              <DatePicker.RangePicker
                onChange={(e, dates) => {
                  if (!e) {
                    return;
                  }
                  handleRangeChange(dates);
                }}
                value={[moment(selectedRange[0]), moment(selectedRange[1])]}
                disabledDate={(current) =>
                  current.isAfter(moment().subtract(0, "day"))
                }
                format="YYYY-MM-DD"
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-start",
            }}
          >
            <div>
              <Card>
                <div style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <div>Total Rides</div>
                    <div style={{ fontWeight: "bold" }}>
                      {(stats.supervisor_rides?.count || 0) +
                        (stats.customer_rides?.count || 0) +
                        " rides"}
                    </div>
                  </div>
                  <div style={{ marginRight: 10, flex: 1 }}>
                    <div>Total Amount</div>
                    <div style={{ fontWeight: "bold" }}>
                      {"₹" +
                        ((stats.supervisor_rides?.total_cost || 0) +
                          (stats.customer_rides?.total_cost || 0))}
                    </div>
                  </div>
                </div>
              </Card>

              <Card style={{}}>
                <Space direction="horizontal">
                  <span style={{ color: "#a7a7a7" }}>Difference</span>
                  <div>By Cost</div>
                  <Switch
                    onChange={() => {
                      if (ativeKey === "cost") {
                        setActiveKey("count");
                      } else {
                        setActiveKey("cost");
                      }
                    }}
                  />
                  <div>By Rides</div>
                </Space>
                <div
                  style={{
                    width: 350,
                    height: 300,
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      fontSize: 11,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: 5,
                          height: 5,
                          marginRight: 5,
                          backgroundColor: COLORS[0],
                        }}
                      />
                      <div>Supervisor</div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: 5,
                          height: 5,
                          marginRight: 5,
                          backgroundColor: COLORS[1],
                        }}
                      />
                      <div>User</div>
                    </div>
                  </div>
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart width={400} height={400}>
                      <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        // labelLine={false}
                        label={renderCustomizedLabel}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey={ativeKey}
                      >
                        {data.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </Card>
            </div>
            <div style={{ width: "50vw", margin: 15 }}>
              <h3>Rides By Dock Stations</h3>
              <Table
                dataSource={Object.values(stats.dock_rides)}
                pagination={false}
                columns={[
                  {
                    title: "Dock Station",
                    dataIndex: "dock_station",
                  },
                  {
                    title: "Rides",
                    dataIndex: "rides",
                  },
                  {
                    title: "Total Collection",
                    dataIndex: "total_cost",
                    render: (value) => {
                      return "₹ " + value;
                    },
                  },
                ]}
                size="small"
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Dashboard;
